// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const PartnerCard = dynamic(() => import('./PartnerCard').then(mod => mod.PartnerCard));

export const PartnerCardConfig = {
  emptyLabel: 'PartnerCard',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/partnercard`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PartnerCardEditable = (props: any) => {
  return (
    <EditableComponent config={PartnerCardConfig} {...props}>
      <PartnerCard {...props} />
    </EditableComponent>
  );
};
